module.exports = __webpack_public_path__ + "static/media/sleep-and-relaxation@3x.63e7e016.png";